export const extractErrorMessage = (error) =>
    error?.response?.data?.title ||
    error?.response?.data?.message ||
    error?.response?.data?.Message ||
    error?.response?.data ||
    error?.response ||
    error?.message;
export const extractErrorMessageRejected = (payload) =>
    payload?.response?.data?.title?.toString() ||
    payload?.response?.data?.Message?.toString() ||
    payload?.response?.data?.message?.toString() ||
    payload?.response?.data?.toString() ||
    payload?.response?.toString() ||
    payload?.err?.toString() ||
    payload?.data?.title?.toString() ||
    payload?.data?.Message?.toString() ||
    payload?.data?.message?.toString() ||
    payload?.data?.toString() ||
    payload?.result?.toString() ||
    payload?.title?.toString() ||
    payload?.Message?.toString() ||
    payload?.message?.toString() ||
    payload?.error?.statusText?.toString() ||
    payload?.error?.toString() ||
    payload?.toString() ||
    "API Response Invalid.";